import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/cube-animation.css';
import SchoolIcon from "@material-ui/icons/School";
import SingleSlide from "./SingleSlide/SingleSlide";
import "./CertificateSlides.css";
import data from "./CertificationData";
const CertificateSlides = ()=>{    
    return( 
    <div >
    <h2 className="section__title" data-aos="fade-left">
        My <span className="different">Certifications <SchoolIcon /></span>
    </h2>
    <AwesomeSlider 
    className='slide__container' 
    animation="cubeAnimation"
    mobileTouch={true}>
        {data?.map((item,i)=>{
        return (<div key={i}><SingleSlide item={item}  /></div>)})}
    </AwesomeSlider>
  </div>)
};

export default CertificateSlides;